<template>
  <v-container v-if="this.zamawiajacy" class="page">
<table>
  <thead>
  <tr><td>

<div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
  <div class="left-cointainer">
    <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
  </div>
  <div class="right-cointainer">
    Tutore Poland Sp. z o.o.<br>
    ul. Piotrkowska 157A, 90-440 Łódź<br>
    NIP: 7272812193
  </div>
</div>

  </td></tr>
  </thead>
<tbody>
<tr><td>

<p align="center" style="margin-top:20px;">
    <strong>UMOWA O WSPÓŁPRACY</strong>
</p>
<p>
    Zawarta w Łodzi pomiędzy:
</p>
<p><strong>Zleceniodawcą:</strong></p>
<p>
  <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Łodzi Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod nr KRS: 0000670834, NIP: 727-28-12- 193, REGON: 366891567, kapitał zakładowy 3 329 200,00 zł  reprezentowaną przez <strong>...</strong>
</p>
<p>a</p>
<p>
  <strong>Zleceniobiorcą:</strong>
  <br/>
  Panią/Panem
  <br/>
  Imię i nazwisko: <strong>...</strong>
  <br/>
  PESEL: <strong>...</strong>
  <br/>
  Adres zamieszkania: <strong>...</strong>
  <br/>
  Nr telefonu: <strong>...</strong>
  <br/>
  e-mail: <strong>...</strong>
  <br/>
  Nr konta bankowego: <strong>...</strong>
  <br/>
  <br/>

  prowadzącą/cym działalność gospodarczą pod firmą:
  <br/>
  Nazwa firmy: <strong>...</strong>
  <br/>
  Siedziba firmy: <strong>...</strong>
  <br/>
  NIP: <strong>...</strong>
  <br/>
  REGON: <strong>...</strong>
  <br/>
  <br/>

  <p>zwanymi dalej łącznie <strong>Stronami</strong> o następującej treści:</p>

<p align="center" style="margin-bottom: 0px;">
  <strong>§ 1 Przedmiot umowy</strong>
</p>
<p style="margin-bottom: 0px;">Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
</p>
<ol>
  <li>rzetelne przygotowanie i prowadzenie zajęć zdalnych lub stacjonarnych dla wszystkich uczestników kursów organizowanych przez Zleceniodawcę zgodnie z programem edukacyjnym wskazanym przez Zleceniodawcę oraz harmonogramem zajęć. Harmonogram może mieć formę pliku elektronicznego; prowadzenie/animowanie zajęć interaktywnych.</li>
  <li>rzetelne prowadzenie dokumentacji potwierdzającej realizację zajęć, zawierającej w szczególności: dzienniki zajęć, listy obecności, dokumentację dotyczącą ewaluacji uczniów, sprawozdania z realizacji zajęć oraz raportów wymaganych przez Klientów B2B - w formie oraz terminach ustalonych przez Zleceniodawcę;</li>
  <li>terminowe wykonywanie wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych;</li>
  <li>prowadzenie zajęć odrobieniowych;</li>
  <li>dbanie o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia;</li>
  <li>współpraca z osobami wyznaczonymi przez Zleceniodawcę, przy czym Zleceniobiorca zobowiązany jest do regularnego i niezwłocznego (najpóźniej na koniec każdego dnia roboczego) odczytywania wiadomości wysyłanych przez te osoby poprzez pocztę e-mail, wiadomości sms lub poprzez komunikatory internetowe i w razie potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w tym szczególnie:
    <ol type="a">
      <li>przekazywanie niezbędnych informacji w zakresie określonym w danej sytuacji,</li>
      <li>udział w zebraniach, rozmowach wizytacyjnych i ewaluacjach;</li>
    </ol>
  </li>
  <li>współpraca z kursantami lub w przypadku uczniów niepełnoletnich - ich rodzicami lub opiekunami prawnymi w tym szczególnie udzielanie niezbędnych informacji dotyczących usługi (np. przekazywanie prac domowych, sprawdzanie i przekazywanie raportów z postępów uczniów) - udział w spotkaniach lub zebraniach, w ściśle określonych przez Zleceniodawcę terminach;</li>
  <li>inne zadania i projekty zlecone przez Zleceniodawcę.</li>
</ol>
<p>Celem zapewnienia warunków do wykonania niniejszej Umowy, Zleceniodawca zobowiązuje się do udostępnienia aktualnie posiadanych materiałów  dydaktycznych. Powyższe nie obejmuje sprzętu elektronicznego (komputer, sprzęt nagłaśniający itp.), które Zleceniobiorca zobowiązany jest zorganizować na własny koszt.</p>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 2 Wykonywanie umowy</strong>
</p>
<ol>
  <li>Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością.</li>
  <li>Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się będzie online za pośrednictwem platform udostępnionych przez Zleceniodawcę lub w formule stacjonarnej w wybranej placówce Zleceniodawcy lub u Klienta. Forma prowadzenia zajęć określona zostanie w harmonogramie zajęć. Zleceniodawca umożliwi Zleceniobiorcy korzystanie z platform niezbędnych do prowadzenia zajęć.</li>
  <li>Strony ustalają, iż za jednostkę obliczeniową przyjmuje się 60 minut zajęć według ustalonego harmonogramu.</li>
  <li>Łączny wymiar godzin dydaktycznych do wykonania będzie określony w harmonogramie każdorazowo przez Zleceniodawcę z wyprzedzeniem i podsumowany na koniec każdego miesiąca kalendarzowego.</li>
  <li>Strony dopuszczają zmianę dat i godzin zajęć określonych w harmonogramie wyłącznie za obopólną zgodą.</li>
  <li>Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w warunkach całkowitej niezależności od Zleceniodawcy. W szczególności Zleceniodawca nie będzie uprawniony do wykonywania wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy.</li>
  <li>Zleceniobiorca nie może zlecać wykonania przedmiotu niniejszej umowy osobom trzecim.</li>
  <li>Zleceniodawca za zgodą zleceniobiorcy dopuszcza możliwość zlecenia usług w stacjonarnej jednostce uzgodnionej przez obie strony.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 3 Warunki świadczenia usług</strong>
</p>
  <ol>
    <li>Zleceniobiorca, zobowiązuje się do należytego świadczenia usług, w szczególności do:
        <ol type="a">
            <li>prowadzenia zajęć wskazanych w §1 zgodnie z harmonogramem przesłanym przez Zleceniodawcę lub osobę wskazaną przez niego najpóźniej ostatniego dnia miesiąca poprzedzającego miesiąca, w którym zlecenie ma zostać wykonane;</li>
            <li>współpracy ze Zleceniodawcą lub osobę wskazaną przez niego,</li>
            <li>rzetelnego prowadzenia dokumentacji potwierdzającej realizację zajęć edukacyjnych, zawierającej w szczególności: dzienniki zajęć, listy obecności, dokumentację dotyczącą ewaluacji uczniów, sprawozdania z realizacji zajęć - w formie ustalonej przez Zleceniodawcę;</li>
            <li>prowadzenia zajęć odrobieniowych;</li>
            <li>prowadzenia inwentaryzacji (zwrot udostępnionych na czas trwania umowy zasobów)</li>
            <li>realizowania celów projektu w zakresie zajęć poprzez:
                <ul>
                    <li>motywowanie ucznia do samodzielnej pracy i przezwyciężania trudności,</li>
                    <li>kształcenie umiejętności niezbędnych do dalszej nauki,</li>
                    <li>kształcenie postawy badawczej,</li>
                    <li>naukę logicznego myślenia,</li>
                    <li>prezentowanie efektów swojej pracy;</li>
                </ul>
            </li>
            <li>wykonywania wszystkich wytycznych organizacyjnych Zleceniodawcy w terminach przez niego określonych;</li>
            <li>świadczenia usług w sposób zgodny z przepisami i zasadami bezpieczeństwa i higieny pracy;</li>
        </ol>
    </li>
    <li>Zleceniobiorca zobowiązany jest do rzetelnego przygotowania i prowadzenia zajęć według własnej inwencji na podstawie programu edukacyjnego Zleceniodawcy oraz zgodnie z ustalonym harmonogramem.</li>
    <li>Zleceniobiorca odpowiedzialny jest za jakość i terminowość prowadzonych zajęć.</li>
    <li>Zleceniobiorca ponosi pełną odpowiedzialność za szkody wyrządzone przez swoje działania lub      zaniechania podczas wykonywania przedmiotu umowy, w szczególności w razie niedotrzymania terminu wykonania zlecenia Zleceniobiorca odpowiada za szkody poniesione przez Zleceniodawcę, natomiast przy  stwierdzeniu błędów i wad przedmiotu umowy – zobowiązany jest do bezpłatnego ich usunięcia.</li>
    <li>Zleceniobiorca zobowiązany jest do bezzwłocznego informowania Zleceniodawcy o każdym przypadku uniemożliwiającym mu realizację zajęć zgodnie z harmonogramem.</li>
    <li>Zleceniobiorca nie może zlecać wykonania przedmiotu niniejszej umowy osobom trzecim.</li>
    <li>Naruszenie zakazu, o którym mowa w ust. 6 spowoduje, iż osoba trzecia nie zostanie dopuszczona do wykonania jakichkolwiek czynności i nie otrzyma z tego tytułu żadnego wynagrodzenia.</li>
  </ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 5px;">
  <strong>§ 4 Absencje i powiadamianie o nich</strong>
</p>
<ol>
  <li>W przypadku niemożności przeprowadzenia zajęć określonych w § 1 w terminach określonych w harmonogramie z przyczyn leżących po stronie Zleceniobiorcy zobowiązuje się on do niezwłocznego powiadomienia Zleceniodawcy o zaistniałym fakcie, nie później niż 7 dni przed planowanymi zajęciami. W takim przypadku Zleceniodawca może wyznaczyć osobę, która zastąpi Zleceniobiorcę w wykonaniu zlecenia opisanego w niniejszej umowie.</li>
  <li>W przypadku nagłej niedyspozycji wynikającej z choroby lub złego stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie zachować 7-dniowego okresu powiadomienia o niemożności wykonywania zlecenia. Zleceniobiorca zobowiązuje się niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia i minimalnie 2 godziny przed rozpoczęciem planowanych zajęć, powiadomić o takiej sytuacji Zleceniodawcę.</li>
  <li>W przypadku nieprzeprowadzenia zajęć w terminie wynikającym z harmonogramu i nie powiadomienia o tym fakcie Zleceniodawcy z wyprzedzeniem nie mniejszym niż 7 dni przed planowanymi zajęciami, Zleceniodawca może rozwiązać umowę ze skutkiem natychmiastowym bez zachowania okresu wypowiedzenia. W takim przypadku, niezależnie od możliwości wypowiedzenia umowy, Zleceniodawca może ponadto dochodzić kary umownej w wysokości 5 000 zł (słownie: pięć tysięcy złotych) od Zleceniobiorcy za poniesione straty, Zleceniodawca może także dochodzić odszkodowania przenoszącego wartość zastrzeżonej kary umownej. Zleceniodawca uprawniony jest do potrącenia kary umownej z przysługującego Zleceniobiorcy wynagrodzenia, na co Zleceniobiorca niniejszym wyraża zgodę. Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających powiadomienie Zleceniodawcy o niemożliwości przeprowadzenia zajęć.</li>
  <li>W przypadku niemożności przeprowadzenia przez Zleceniobiorcę zajęć zaplanowanych według harmonogramu i niemożliwości znalezienia zastępstwa przez Zleceniodawcę, Zleceniobiorca zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej nieodbytym zajęciom.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 5 Czas obowiązywania</strong>
</p>
<ol>
  <li>Strony zawierają umowę na czas określony, tj. od ... do dnia ....</li>
  <li>Strony mogą rozwiązać Umowę z zachowaniem miesięcznego okresu wypowiedzenia, ze skutkiem prawnym na koniec miesiąca kalendarzowego, po pisemnym przesłaniu informacji o wypowiedzeniu umowy (z .zastrzeżeniem ustępu 3.). Oświadczenie Zleceniobiorcy wymaga formy pisemnej pod rygorem nieważności; oświadczenie Zleceniodawcy może być złożone zarówno w formie pisemnej, jak i dokumentowej.</li>
  <li>Zleceniodawca ma prawo rozwiązać niniejszą umowę bez zachowania okresu wypowiedzenia jeżeli Zleceniobiorca rażąco sprzeciwia się postanowieniom niniejszej umowy, przez co strony rozumieją w szczególności:
    <ol type="a">
      <li>zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków określonych w § 1 pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń,</li>
      <li>złamanie przez Zleceniobiorcę zakazu konkurencji,</li>
      <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych,</li>
      <li>wszelkie inne naruszenia niniejszej umowy.</li>
    </ol>
  </li>
  <li>Oświadczenie Zleceniodawcy o rozwiązaniu umowy ze skutkiem natychmiastowym może być złożone zarówno w formie pisemnej, jak i dokumentowej.</li>
  <li>W przypadku rozwiązania umowy Zleceniobiorca zobowiązuje się do zwrotu materiałów udostępnionych na czas trwania umowy przez Zleceniodawcę w terminie do 14 dni od dnia rozwiązania lub wygaśnięcia umowy. W przypadku braku zwrotu materiałów w wyznaczonym terminie Zleceniodawca może nałożyć na Zleceniobiorcę karę umowną o wartości otrzymanych materiałów. Dodatkowo Zleceniobiorca może zostać obciążony kosztami przesyłki za zwrócone materiały.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 6 Wynagrodzenie</strong>
  </p>
<ol>
    <li>Tytułem wynagrodzenia za prawidłowe wykonanie prowadzonych zajęć objętych Umową, Zleceniobiorca otrzymuje: ...,00 zł netto (słownie: ... złotych netto) za jedną lekcję rozumianą zgodnie z § 2 ust. 3 niniejszej umowy w wysokości wynikającej ze stawki godzinowej oraz liczby lekcji przeprowadzonych w danym miesiącu. Zleceniobiorcy nie przysługuje dodatkowe wynagrodzenie za dokonanie czynności dodatkowych związanych z przygotowaniem, organizacją i raportowaniem zajęć zgodnie z § 2 ust. 3 niniejszej umowy.</li>
    <li>W przypadku prowadzenia jako nauczyciel zajęć stacjonarnych w jednostkach oświatowych (żłobki,przedszkola, szkoły podstawowe, szkoły średnie, uczelnie wyższe) przysługuje dodatek wysokości 10 zł netto za jedną lekcję rozumianą zgodnie z § 2 ust. 3.</li>
    <li>W przypadku prowadzenia jako animator zajęć stacjonarnych w jednostkach oświatowych (żłobki, przedszkola, szkoły podstawowe, szkoły średnie,uczelnie wyższe) stawka wynosi 30 zł netto za jedną lekcję rozumianą zgodnie z § 2 ust. 3.</li>
    <li>Strony ustalają miesięczny okres rozliczeniowy świadczonych usług. Zleceniobiorca będzie wystawiał fakturę VAT po zakończeniu okresu rozliczeniowego.</li>
    <li>Wypłata wynagrodzenia za każdy miesiąc świadczenia usług następuje w ciągu 14 dni od wystawienia faktury VAT (według terminu wskazanego na fakturze). Wynagrodzenie jest płatne przelewem na nr konta bankowego wskazany na fakturze wystawionej przez Zleceniobiorcę i zaakceptowanej przez Zleceniodawcę. Warunkiem wypłaty wynagrodzenia jest wykonanie przedmiotu umowy i przesłanie sprawozdania z jego wykonania wg wytycznych Tutore Poland oraz wystawienie i przesłanie faktury elektronicznej do osoby wyznaczonej. Zleceniobiorca oświadcza, że wskazany na fakturze VAT rachunek bankowy będzie rachunkiem rozliczeniowym służącym wyłącznie do celów rozliczeń z tytułu prowadzonej przez niego działalności gospodarczej i będzie rachunkiem bankowym zgłoszonym do elektronicznego rejestru prowadzonego przez Szefa Krajowej Administracji Skarbowej w ramach tzw. „białej listy podatników” (zwanego dalej „Wykazem”), o którym mowa w ustawie o podatku od towarów i usług. Jeżeli przed realizacją płatności Zleceniodawca poweźmie informację o braku zewidencjonowania rachunku bankowego w Wykazie, Zleceniodawca będzie uprawniony do dokonania zapłaty na rachunek bankowy Zleceniobiorcy wskazany w Wykazie, co będzie stanowić wykonanie zobowiązania Zleceniodawcy.</li>
    <li>Zleceniobiorca jest zobowiązany prowadzić dokumentację potwierdzającą realizację zajęć w danym miesiącu, w szczególności dzienników zajęć i list obecności uczniów i przesłać ją osobie wyznaczonej najpóźniej do ostatniego dnia miesiąca, za który Zleceniobiorcy przysługuje wynagrodzenie z tytułu  świadczenia usług.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 7 Informacje poufne</strong>
</p>
<ol>
  <li>
    Przez Informacje Poufne strony rozumieją wszelkie informacje przekazane Zleceniobiorcy przez Zleceniodawcę lub uzyskane przez Zleceniobiorcę w inny sposób w związku z wykonywaniem niniejszej umowy, obejmujące informacje techniczne, technologiczne, organizacyjne lub inne informacje posiadające wartość gospodarczą, które dotyczą Zleceniodawcy, jego działalności i Klientów, a w szczególności materiały dydaktyczne wykorzystywane przez Zleceniobiorcę, baza danych kontaktowych do Klientów Zleceniodawcy (w tym także klientów, którzy zakończyli współpracę ze Zleceniodawcą do 12 miesięcy po zakończeniu umowy), systemy komputerowe oraz pozostałe informacje uzyskiwane od Zleceniodawcy w trakcie wykonywania umowy.
  </li>
  <li>
    Zleceniobiorca zobowiązuje się, że Informacje Poufne uzyskane w ramach niniejszej umowy będą utrzymywane w tajemnicy przez Zleceniobiorcę i wykorzystywane wyłącznie do wykonania niniejszej umowy. Informacje Poufne nie będą wykorzystywane w innych celach ani nie będą ujawniane, czy udostępniane osobom trzecim, w całości lub w części. Zobowiązanie do zachowania poufności dotyczy Informacji Poufnych uzyskanych przez Zleceniobiorcę od Zleceniodawcy w formie pisemnej oraz ujawnionych Zleceniobiorcy ustnie, wizualnie, elektronicznie lub w inny sposób. Zleceniobiorca zobowiązuje się utrzymywać otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich komukolwiek bez pisemnej zgody Zleceniodawcy.
  </li>
  <li>
    Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany będzie zwrócić Zleceniodawcy w ciągu 3 dni wszelkie Informacje Poufne, wraz z dokumentacją i innymi nośnikami, na których zostały one utrwalone, jak również, kopiami dokumentacji lub nośników zawierających takie Informacje. Zleceniobiorca zobowiązuje się do usunięcia z pamięci komputerów oraz innych urządzeń wszystkich otrzymanych lub wykonanych materiałów w sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w przyszłości w jakiejkolwiek formie.
  </li>
  <li>
    W przypadku naruszenia przez Zleceniobiorcę postanowień ustępów poprzedzających, w szczególności, poprzez niezgodne z tą umową ujawnienie lub udostępnienie materiałów oraz Informacji Poufnych,Zleceniobiorca zobowiązany będzie do zapłaty na rzecz Zleceniodawcy kary umownej w wysokości 5 000,00 zł (słownie: pięć tysięcy złotych) za każde takie naruszenie. Kara taka płatna będzie w terminie 14 dni od daty złożenia przez Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą umową. Zleceniodawca uprawniony jest do potrącenia kary umownej z przysługującego Zleceniobiorcy wynagrodzenia, na co Zleceniobiorca niniejszym wyraża zgodę.
  </li>
  <li>
    Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy wynikających z naruszenia przez Zleceniobiorcę postanowień niniejszej umowy przewyższać będzie wysokość kary umownej wskazanej w ust. 4 niniejszego paragrafu, Zleceniodawca może dochodzić odszkodowania uzupełniającego na zasadach ogólnych wynikających z Kodeksu cywilnego.
  </li>
  <li>
    Za naruszenie zasad opisanych w niniejszej umowie, Zleceniodawca uznaje także każdorazowe wykorzystanie materiałów dydaktycznych Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów nauczania osób, które nie są Klientami Zleceniodawcy.
  </li>
  <li>
    Niezależnie od wygaśnięcia czy rozwiązania niniejszej umowy, zobowiązania Zleceniobiorcy zachowania w poufności Informacji Poufnych pozostają w mocy bezterminowo.
  </li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px;">
      <strong>§ 8 Zakaz konkurencji</strong>
    </p>
    <ol>
      <li>
        Zleceniobiorca jest zobowiązany do powstrzymania się od podejmowania i wykonywania działalności konkurencyjnej wobec Zleceniodawcy, w czasie obowiązywania niniejszej Umowy - zgodnie z definicją opisaną w niniejszym paragrafie.
        </li>
        <li>
          Postanowienia dotyczące zakazu konkurencji, Strony określają szczegółowo w dalszej części niniejszego paragrafu. 
      </li>
      <li>
        Za działalność konkurencyjną w rozumieniu niniejszego paragrafu Strony uznają oferowanie lub świadczenie przez Zleceniobiorcę, na jakiejkolwiek podstawie lub formie, usług edukacyjnych podobnych do usług oferowanych przez Zleceniodawcę, na rzecz klientów Zleceniodawcy, którzy zawarli ze Zleceniodawcą umowę najpóźniej w dniu wygaśnięcia albo rozwiązania niniejszej umowy.
      </li>
      <li>
        Za działalność konkurencyjną uznaje się również:
        <ol type="a">
          <li>
            świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu prowadzącego działalność konkurencyjną wobec Zleceniodawcy (zgodnie z definicją zawartą w ust. 5 niniejszego paragrafu), w tym świadczenie usług na rzecz takich podmiotów na podstawie jakiejkolwiek innej umowy cywilnoprawnej,
          </li>
          <li>
            prowadzenie przez Zleceniobiorcę działalności konkurencyjnej, zgodnie z definicją opisaną w ust. 3, wobec Zleceniodawcy, także za pośrednictwem osób trzecich,
          </li>
          <li>
            bycie wspólnikiem lub członkiem organów spółki prowadzącej działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5,
          </li>
          <li>
            pełnienie funkcji agenta, pełnomocnika lub prokurenta w podmiotach prowadzących działalność konkurencyjną wobec Zleceniodawcy, zgodnie z definicją opisaną w ust. 5.
          </li>
        </ol>
      </li>
      <li>
        Za podmiot prowadzący działalność konkurencyjną wobec Zleceniodawcy uznaje się każdy podmiot, który prowadzi działalność o tożsamym  charakterze do działalności prowadzonej przez Zleceniodawcę, wykorzystując te same lub podobne technologie, które nie są ogólnodostępne (tj. nie są powszechnie znane), oraz działa w oparciu o zbliżony model biznesowy do modelu Zleceniodawcy. Konkurencyjność tych podmiotów polega na tym, że oferują one usługi lub produkty edukacyjne, które mogą być bezpośrednią alternatywą dla usług oferowanych przez Zleceniodawcę, lub mają na celu pozyskanie tych samych klientów, korzystając z podobnych technologii i struktur organizacyjnych.
      </li>
      <li>
        Zleceniobiorca zobowiązuje się, że po wygaśnięciu albo rozwiązaniu niniejszej umowy nie będzie wykorzystywał materiałów, które zostały udostępnione mu przez Zleceniodawcę w trakcie współpracy.
      </li>
      <li>
        W przypadku, gdy w czasie obowiązywania niniejszej Umowy klient Zleceniodawcy złoży Zleceniobiorcy propozycję współpracy, Zleceniobiorca zobowiązany jest poinformować klienta o obowiązującym go zakazie konkurencji i odmówić podjęcia współpracy. Zleceniobiorca ma również obowiązek niezwłocznie poinformować Zleceniodawcę o zaistniałej sytuacji.
      </li>
      <li>
        Zleceniodawca zastrzega sobie prawo do weryfikacji przestrzegania przez Zleceniobiorcę postanowień niniejszego paragrafu.
      </li>
      <li>
        W przypadku naruszenia zakazu konkurencji, Zleceniobiorca zobowiązany jest do zapłaty Zleceniodawcy kary umownej w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy złotych) za każdy przypadek naruszenia. Zleceniodawcy przysługuje również prawo do dochodzenia odszkodowania na zasadach ogólnych, w wysokości przewyższającej zapłaconą karę umowną.
      </li>
    </ol>
    <br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 9 Kompletność oraz zmiana umowy</strong>
</p>
<ol>
  <li>Niniejsza umowa rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
  <li>Strony oświadczają, że poza niniejszą umową nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
  <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności. 4. Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności. Oświadczenie Zleceniodawcy może być również złożone w formie dokumentowej, co traktowane jest jako spełnienie wymogu złożenia oświadczenia w formie pisemnej.</li>
</ol>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 10 Spory i sąd właściwy</strong>
</p>
<p style="margin-bottom: 0px;">
  Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy. Postanowienia zdań poprzednich nie są zapisem na sąd polubowny. 
</p>
<br>

<p align="center" style="margin-bottom: 0px; margin-top: 10px;">
  <strong>§ 11 Ilość umów</strong>
</p>
<p>Umowę sporządzono w dwóch jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</p>
<br>
<br>

 <div>
  <p class="underline"><b>Załączniki stanowiące integralną część umowy:</b></p>
  <ol>
    <li class="underline">Informacja o monitoringu zajęć on - line</li>
    <li class="underline">Klauzula informacyjna RODO</li>
    <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
  </ol>
</div>

<div class="cointainer" style="margin-top: 30px; margin-bottom: 30px;">
    <div class="left-cointainer">
      <span style="margin-left: 0%;"><b>Podpis zleceniodawcy</b></span>
        <p><b>...</b></p>
    </div>
    <div class="right-cointainer">
      <span style="margin-left: 0%;"><b>Podpis zleceniobiorcy</b></span>
      <br>
        ...
    </div>
</div>

<div style="page-break-before: always;">
  <p class="underline">Załącznik nr 1</p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>Informacja o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line</strong></p>
  <br>
  <p>Informujemy, iż Tutore Poland Sp. z o.o. korzysta z środków technicznych umożliwiających monitoring prowadzonych zajęć on – line oraz nagrywania szkoleń wewnętrznych on - line. Monitoringiem są objęte urządzenia rejestrujące obraz oraz dźwięk, z których korzysta użytkownik w celu realizacji zajęć online tj. platforma Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń wewnętrznych online aplikacja Zoom. Tutore Poland Sp. z o.o. stosuje monitoring w następujących celach: zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez pracowników/zleceniobiorców, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych on – line w celu zapewnienia możliwości udostępnienia nagrań nowym pracownikom/zleceniobiorcom. Informujemy, iż: system monitoringu audiowizualnego i dźwiękowego zajęć online składa się z systemu rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć online posiadają osoby upoważnione przez Zarząd Tutore Poland Sp. z o.o. tj. Manager Działu Call Center, Dyrektor ds. Zarządzania Procesami, Teamleader Działu Infolinii, osoby, które mają wgląd do zarejestrowanego obrazu mają świadomość odpowiedzialności za ochronę danych osobowych oraz posiadają stosowne upoważnienie wydane przez Administratora danych osobowych. W toku nagrania dochodzi do przetwarzania danych osobowych w postaci głosu, wizerunku oraz imienia i nazwiska zleceniobiorcy prowadzącego zajęcia lub szkolenie. Administratorem danych osobowych uzyskanych w ramach monitoringu zajęć on – line i w toku nagrywania szkoleń wewnętrznych on - line jest Tutore Poland Sp. z o.o., który w związku z opisaną powyżej czynnością zamieszcza poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania danych osobowych.
  </p>
  <br>
  <p><strong>Klauzula informacyjna Tutore Poland Sp. z o.o. dla pracowników/zleceniobiorców w związku z przetwarzaniem danych osobowych w ramach monitoringu zajęć on – line i nagrywania szkoleń wewnętrznych on - line</strong></p>
  <p>Na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, Tutore Poland Sp. z o.o. informuje:</p>
  <ol>
    <li>Administratorem Danych Osobowych jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, tel.  535 933 870 info@tutore.eu, dalej ADO.</li>
    <li>ADO przetwarza dane osobowe dla celach wskazanych w informacji monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line – podstawę prawną przetwarzania stanowi dobrowolna zgoda nagrywanego (art. 6 ust. 1 lit. a RODO)</li>
    <li>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</li>
    <li>Dane osobowe przechowywane będą przez okres do 3 miesięcy. W przypadku, w którym nagrania zajęć on - line stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub ADO powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu.</li>
    <li>Odbiorcami danych osobowych mogą być organy publiczne, organy wymiaru sprawiedliwości, jednostki świadczące na rzecz ADO usługi doradcze (w szczególności doradztwo prawne).</li>
    <li>Osoba której dane są przetwarzane ma prawo:
      <ol type="a">
        <li>dostępu do swoich danych oraz otrzymania ich kopii,</li>
        <li>prawo do sprostowania (poprawiania) swoich danych,</li>
        <li>prawo do ograniczenia przetwarzania,</li>
        <li>prawo do bycia zapomnianym,</li>
        <li>prawo do sprzeciwu,</li>
        <li>prawo do przenoszenia danych,</li>
        <li>prawo do cofnięcia zgody na przetwarzanie,</li>
        <li>prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</li>
      </ol>
    </li>
    <li>Osoba, której dane są przetwarzane uprawniona jest do cofnięcia zgody na przetwarzanie w każdym czasie, przy czym oświadczenie o cofnięciu zgody wywołuje skutki z chwilą jego złożenia i nie ma wpływu na proces przetwarzania danych przed jego złożeniem.</li>
    <li>Podanie danych osobowych w zakresie objętym klauzulą jest całkowicie dobrowolne, ale niezbędne dla realizacji celu przetwarzania oraz należytej realizacji zawartej przez strony umowy.</li>
    <li>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</li>
  </ol>
</div>

<div style="page-break-before: always; margin-top: 30px;">
  <p><strong>Załącznik 2 Klauzula informacyjna Tutore Poland Sp. z o.o</strong></p>
  <p align="center"><strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</strong></p>
  <ol>
  <li>Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu.</li>
  <li>Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.</li>
  <li>Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.</li>
  <li>Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
    <ol>
      <li>zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,</li>
      <li>wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,</li>
      <li>potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,</li>
      <li>realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
      <li>realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika składek na ubezpieczenie społeczne i zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,</li>
      <li>realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,</li>
      <li>bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,</li>
      <li>zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
      <li>zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
      <li>zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
      <li>tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,</li>
      <li>dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.</li>
    </ol>
  </li>
  <li>Odbiorcami Pani/Pana danych osobowych będą:
    <ol>
      <li>organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;</li>
      <li>zakłady opieki zdrowotnej w celach związanych z medycyną pracy;</li>
      <li>podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,</li>
      <li>biura księgowe:</li>
      <li>banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;</li>
      <li>kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z zajmowanym przez Zleceniobiorcę stanowiskiem pracy;</li>
      <li>współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,</li>
      <li>podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.</li>
      <li>instytucje ubezpieczeniowe</li>
      <li>organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą)</li>
      <li>podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)</li>
    </ol>
  </li>
  <li>Ma Pani/Pan prawo do:
    <ol>
      <li>dostępu do danych — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);</li>
      <li>otrzymania kopii danych — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);</li>
      <li>sprostowania — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);</li>
      <li>usunięcia danych — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);</li>
      <li>ograniczenia przetwarzania — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
        <ul>
          <li>kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,</li>
          <li>przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,</li>
          <li>Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;</li>
          <li>wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;</li>
        </ul>
      </li>
      <li>przenoszenia danych — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);</li>
      <li>sprzeciwu — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);</li>
      <li>prawo wniesienia skargi do organu nadzorczego – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
        <ul>
          <li>pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,</li>
          <li>elektronicznie za pośrednictwem platformy ePUAP.</li>
        </ul>
      </li>
    </ol>
  </li>
  <li>W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.</li>
  <li>Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.</li>
  </ol>
</div>

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          <ol>
            <li>Ja niżej podpisany/a oświadczam, iż:
              <ol type="a">
                <li>
                  zapoznałem/am się z Informacją o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on - line oraz Klauzulą informacyjną i przyjmuję ją do wiadomości,
                </li>
                <li>
                  treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.
                </li>
                </ol>
                <li>
                  W sposób całkowicie dobrowolny, wyrażam zgodę na przetwarzanie moich danych osobowych w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.
                </li>
                <li>
                  Zostałem/am poinformowany/a, że moje dane osobowe przetwarzane są na podstawie wyrażonej przeze mnie dobrowolnej zgody oraz, że przysługuje mi prawo do jej cofnięcia w każdym czasie, przy czym cofnięcie zgody wywołuje skutki prawne od momentu jego złożenia i będzie pozostawało bez wpływu na przetwarzanie moich danych osobowych dla celów związanych z realizacją badania przed złożeniem oświadczenia o cofnięciu zgody. 
                </li>
                <li>
                  W trybie art. 81 ust.1 ustawy o prawie autorskim i prawach pokrewnych wyrażam zgodę na rozpowszechnianie mojego wizerunku przez Tutore Poland Sp. z o.o. w celach wskazanych w Informacji o monitoringu zajęć on – line i nagrywaniu szkoleń wewnętrznych on – line.
                </li>
            </li>
          </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
            <span style="font-size: 14px;">...</span>
            <br>
            <span>czytelny podpis Zleceniobiorcy</span>
          </div>
        </td>
      </tr>
    </table>
</div>


<div style="page-break-before: always;">
  <div class="cointainer" style="margin-top: 60px;">
    <div class="left-cointainer">
      <p class="underline">Załącznik nr 3 Upoważnienie do przetwarzania danych osobowych</p>
    </div>
    <div class="right-cointainer">
      <p style="margin-bottom: 10px; font-size: 14px;">
    Łódź, dnia ... r.
      </p>
    </div>
</div>
  
  
<p align="center" class="subheading" style="margin-bottom: 10px;">
  <strong>
    Upoważnienie do przetwarzania danych osobowych w zbiorze w wersji papierowej i elektronicznej
  </strong>
</p>
<p class="p-margin">
  Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
</p>
<p class="p-margin">
  z dniem podpisania niniejszego upoważnienia
</p>
<p class="p-margin">
  upoważniam Pana/Panią ... - Zleceniobiorcę Tutore Poland Sp. z o.o.
</p>
<p class="p-margin">
  do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
</p>
  <ol type="a">
    <li>w wersji elektronicznej:
      <ul>
        <li>
          zbiór danych osobowych Uczestników: dzieci, młodzieży i dorosłych korzystających z usług prowadzonych przez Tutore Poland Sp. z o.o. - imię i nazwisko, klasa (jeśli dotyczy), adres zamieszkania,
        </li>
        <li>
          zbiór danych osobowych Klientów: rodziców (opiekunów prawnych) dzieci, młodzieży i dorosłych korzystających z usług oferowanych przez Tutore Poland Sp. z o.o. – imię i nazwisko, adres zamieszkania, telefon kontaktowy, adres e-mail
        </li>
      </ul>
    </li>
  </ol>
<p class="p-margin">
  w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
</p>
<p class="p-margin">
  Niniejsze upoważnienie nie upoważnia do udzielania dalszych upoważnień i wygasa z dniem ustania stosunku pracy, a ponadto może być w każdym czasie zmienione lub odwołane.
</p>
<p class="p-margin">
  Zobowiązuję Pana/Panią do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Pracodawcy - Administratora Danych Osobowych.
</p>
<p class="p-margin">Zobowiązuję Pana/Panią do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o.. wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
<br />
  Naruszenie ww. obowiązków może skutkować poniesieniem odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy o pracę.
</p>

<div class="container" style="page-break-before: always;">
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
      <tr>
        <td id="oswiadczenie">
          <p align="center" class="subheading"><strong>OŚWIADCZENIE</strong></p>
          <ol>
        <li>Ja niżej podpisany/a oświadczam, iż:
        <ol type="a">
          <li>
            zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
          </li>
          <li>
            treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
          </li>
          <li>zobowiązuję się do przetwarzania danych osobowych zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Pracodawcy,</li>
          <li>zobowiązuję się do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Pracodawcy, w tym Polityką Prywatności,</li>
          <li>zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy o współpracę.</li>
          </ol>
        </li>
        </ol>
          <div class="right-cointainer" style="float: right; margin-top: 20px;">
            <span style="font-size: 14px;">...</span>
            <br>
            <span><strong>czytelny podpis</strong></span>
          </div>
      </td>
    </tr>
  </table>
  </div>

<p class="subheading p-margin" style="text-align: center;">
  data i podpis
  <br>
  <strong>...</strong>
</p>
<p class="subheading p-margin" style="text-align: center;">
  ... 
  <br>
  <strong>...</strong>
</p>
<br>
<p>Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy zlecenie - do dnia ...</p>
</div>


</td>
</tr>

</tbody></table>

  
  </v-container>
</template>

<script>
export default {
  name: 'WzorUmowaB2BRegionAbcd',
  data () {
    return {
      zamawiajacy: '',
      imieNazwisko: '',
      zamieszkany: '',
      korespondencyjny: '',
      pesel: '',
      nrRachunku: '',
      nrDowodu: '',
      nrTelefonu: '',
      email: '',
      emeryt: '',
      rencista: '',
      orzeczenieNiepelnosprawnosc: '',
      stopienNiepelnosprawnosc: '',
      student: '',
      jedenyTytulDoUbezpieczenia: '',
      chorobowe: '',
      zatrudnionyUmowaPraca: '',
      nazwaUmowaPraca: '',
      wynagrodzenieUmowaPraca: '',
      ubezpieczenieUmowaPraca: '',
      tytulUbezpieczenieUmowaPraca: '',
      umowaOd: '',
      umowaDo: '',
      urzadSkarbowy: '',
      nrUmowy: '',
      datapocz: '',
      datakon: '',
      wypo: '',
      kwotapokaz: '',
      slowniepokaz: '',
      shortUmowa: '',
      obywatelstwo: '',
      stawka1: '',
      stawka2: '',
      stawka3: '',
      nazwaFirmy: '',
      siedzibaFirmy: '',
      nip: '',
      regon: '',
      kontoBankowe: '',
      rodzajUmowy: '',
      przedmiot: '',
      rozUmowa: '',
    }
  },
  created () {
    Object.entries(this.$route.query).forEach(
      ([key, value]) => { this[key] = value }
    )
  },
  methods: {
    shortNrUmowy () {
      let tab = []
      let shortPosition = ''
      tab = this.nrUmowy.split('/')
      switch(tab[3]) {
        case 'Nauczyciel':
          shortPosition = 'Naucz'
          break;
        case 'Metodyk':
          shortPosition = 'Met'
          break
        case 'TworcaMaterialow':
          shortPosition = 'TMat'
          break
        case 'TworcaMaterialowNauczycielMetodyk':
          shortPosition = 'TMatNauMet'
          break
        case 'TworzenieProgramuNauczania':
          shortPosition = 'TPNau'
          break
        case 'AsystentOrganizacyjny':
          shortPosition = 'AOrg'
          break
        case 'MłodszyAsystentOrganizacyjny':
          shortPosition = 'MAOrg'
          break
        case 'TworzenieMap':
          shortPosition = 'TMapMC'
          break
        default:
          shortPosition = tab[3]
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`
      return shortUmowa
    },
    slownieAngielski() {
      switch(this.kwota) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slownie
      }
    },
    slowniePokazAngielski() {
      switch(this.kwotapokaz) {
        case '25':
          return 'twenty-five'
          break
        case '30':
          return 'thirty'
          break
        case '35':
          return 'thirty-five'
          break
        case '40':
          return 'forty'
          break
        case '45':
          return 'forty-five'
          break
        case '50':
          return 'fifty'
          break
        case '55':
          return 'fifty-five'
          break
        case '60':
          return 'sixty'
          break
        case '65':
          return 'sixty-five'
          break
        case '70':
          return 'seventy'
          break
        case '75':
          return 'seventy-five'
          break
        case '80':
          return 'eighty'
          break
        case '85':
          return 'eighty-five'
          break
        case '90':
          return 'ninety'
          break
        case '95':
          return 'ninety-five'
          break
        default:
          return this.slowniepokaz
      }
    },
    dataObowiazywaniaUmowy () {
      if (this.umowaOd === '' || this.umowaOd === '30-12-1899') {
        return 'dnia podpisania umowy przez obie strony'
      } else {
        return `${this.umowaOd} r.`
      }
    },
    zamawiajacyAngielski() {
      if (this.zamawiajacy === 'Marcin Grzelak - Prezes Zarządu') {
        return 'Marcin Grzelak - Chairman of the Board'
      } else {
        return this.zamawiajacy
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if((day+1) <= 10) {
        day = '0' + day
      }
      let month = today.getMonth()+1;
      if ((today.getMonth()+1) < 10) {
        month = '0' + month
      } 
      const todayDate = day+'-'+month+'-'+today.getFullYear()
      return todayDate
    }
  },
  mounted () {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href
          history.replaceState(history.state, '', '/')
          window.print()
          history.replaceState(history.state, '', currentURL)
        }, 300)
      })
    }
  }
}
</script>

<style scoped>

.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.attachments {
  width: 100%;
}

.pelnomocnictwo {
  background-image: url('/src/assets/pelnomocnictwo_tutore_duze.png');
}
</style>



// WEBPACK FOOTER //
// src/components/WzorUmowaB2BRegionAbcd.vue